import React from 'react'
import styled from '@emotion/styled'
import { Section } from 'components/Common'
import { StepStatus } from 'hooks/useStep'
import { OutlineButton } from './styles'

interface InterstitialStepProps {
  onGetStarted: () => void
}

const InterstitialStep = ({ onGetStarted }: InterstitialStepProps) => {
  return (
    <Root>
      <Section
        title='Connect Leat'
        stepStatus={StepStatus.active}
        stepNumber={1}
        description={
          <>
            Leat becomes the loyalty engine behind your Slerp checkout —
            unifying your offline and online loyalty program. Customers earn on
            Slerp orders and can redeem their rewards at checkout. Three things
            happen in Leat first.
          </>
        }
        action={
          <OutlineButton onClick={onGetStarted}>GET STARTED</OutlineButton>
        }
      />

      <StepList>
        <StepItem>
          <StepTitle>Install Slerp in Leat</StepTitle>
          <StepDescription>
            In your Leat dashboard, open{' '}
            <strong>Integrations Marketplace</strong>, select Slerp and hit{' '}
            <strong>Install</strong> in the top right.
          </StepDescription>
        </StepItem>
        <Divider />
        <StepItem>
          <StepTitle>Create a shop in Leat for each store</StepTitle>
          <StepDescription>
            Every Slerp store that should offer loyalty needs a matching Leat
            shop. You&apos;ll link them together in the next step — you can
            always add more later.
          </StepDescription>
        </StepItem>
        <Divider />
        <StepItem>
          <StepTitle>Copy your personal access token</StepTitle>
          <StepDescription>
            Go to <strong>Auth</strong> in Leat and copy the token. Keep the tab
            open — you&apos;ll paste it on the next screen.
          </StepDescription>
        </StepItem>
      </StepList>
    </Root>
  )
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 920px;
  margin: 0 auto;
`

const StepList = styled.div`
  background-color: #ffffff;
  border: 1px solid #d2d2d9;
  border-radius: 6px;
  padding: 24px;

  display: flex;
  flex-direction: column;
  gap: 12px;
`

const StepItem = styled.div`
  display: flex;
  flex-direction: column;
  color: #4a4a68;
`

const StepTitle = styled.strong`
  font-size: 16px;
  font-weight: 600;
`

const StepDescription = styled.span`
  font-size: 14px;
  font-weight: 400;

  strong {
    font-weight: 700;
  }
`

const Divider = styled.hr`
  border: none;
  border-top: 1px solid #d2d2d9;
  margin: 0;
`

export default InterstitialStep
